export default __webpack_public_path__ + "static/media/icon-gmail.ee4cc821.svg";